var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-90a6afe0\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./removeCross.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppSvgIcon/iconsTemplate/contents/removeCross.vue
// module id = 8f139878ca930e1c87e9
// module chunks = 89